/* ============================================================================
   GC · INSTÄLLNINGAR — driftrattarna, hans kortform
   ----------------------------------------------------------------------------
   RÄTTELSE 2026-08-16: den första versionen påstod att alla fyra rattar i hans
   InstallningarView saknade backend-fält. Fel — tre av fyra finns, under andra
   namn, och gamla designen har justerat dem sedan 30/7 (settings-mode.jsx):

     hans "Lägsta säljpris för sol"   → sellsolar_min_price_ore (styr även den
                                        automatiska solladdningen av bilen —
                                        hans fjärde ratt behövs därför inte)
     hans ratt för nätköp             → maxprofit_import_aversion_kr (kr; UI öre),
                                        hos oss "Egen el först" (v929)
     hans "Handelsmarginal"           → cycle_cost_ore/cycle_cost_kwh, vår
                                        "Batterislitage": HEMS handlar bara när
                                        vinsten överstiger slitaget per kWh
     hans "Prisgräns för solladdning" → finns inte som fält, och ska enligt
                                        backend 16/8 INTE byggas: säljgolvet
                                        ovan styr samma sak i dag. Produkt-
                                        beslut hos André.

   Dessutom har vi rattar han inte har: "Fyll batteriet tidigt",
   "Morgonbuffert" och sedan v930 "Fyll vid billig el" (fill_cheap_level 0–10). Spann bekräftade av backend 16/8: sellsolar 0–500 öre,
   maxprofit 0–0,5 kr (visas som 0–50 öre; taket 1,00 kr = 100 öre sedan 21/9, här sedan v929), cycle_cost 0–100 öre default 10.
   0 = AV, null = flottans värde — två skilda saker.

   Prisgränsen för solladdning byggs INTE som egen ratt (André 16/8): säljgolvet
   ovan styr redan samma sak — under det priset säljs inte solen, den används.
   Två rattar för ett beslut vore två sanningar.

   REGLERNA ÄR SPEC_GRAVIO_USER_MODE_UI §3.3 och de är hårda:
   - null = OJUSTERAD, inte 0. En ojusterad ratt visar flottans värde som ghost
     och skickas ALDRIG i payloaden.
   - En ratt som VAR satt och återställs skickas som explicit null.
   - Master-gaten raderar inga värden när den slås av — backend ignorerar dem.
   - Batterislitaget är INTE gate-styrt: det gäller alltid.

   Sparvägen är gcSaveSettings (gc-core): hela dokumentet, settings_rev med,
   en omläsning vid 409. PATCH /api/settings tar bara ev_session.
   ========================================================================== */

/* Flottans kalibrerade värden — visas som ghost, skickas aldrig.
   Samma tal som settings-mode.jsx FLEET_DEFAULTS; ändras de där ska de
   ändras här. maxprofit visas i öre (backend bär kr). */
const GCI_FLEET = {
  traj_premie_ore_per_kwh_h: 3,
  sellsolar_min_price_ore: 30,
  maxprofit_import_aversion_kr: 25,
  fill_cheap_level: 3,
  soc_planning_buffer_pct: 2,
  soc_buffer_release_ore: 30,
};

const GCI_KNOBS = [
  { field:'traj_premie_ore_per_kwh_h', label:'Fyll batteriet tidigt', min:0, max:15, step:1, unit:'', gated:true,
    desc:'Högre värde = batteriet laddas fullt tidigare på dagen som säkerhet mot prognosfel. Lägre = ren prisoptimering, som kan vänta till de billigaste timmarna.' },
  { field:'sellsolar_min_price_ore', label:'Lägsta säljpris för sol', min:0, max:500, step:5, unit:'öre', gated:true,
    desc:'Under detta pris säljs solen aldrig — den går till huset och batteriet i stället. Ratten styr också den automatiska solladdningen av bilen: under gränsen får bilen ta det överskott batteriet inte hinner ta, över den säljs solen. Planerad laddning påverkas inte — har du satt mål och avresa laddas bilen oavsett pris. 0 stänger av automatiken.' },
  /* v929 (spec Egen el först 25/10): samma etikett, hjälptext och tak som settings-mode.jsx. Taket 100 öre = 1,00 kr, som backend tar emot sedan 21/9. */
  { field:'maxprofit_import_aversion_kr', label:'Egen el först', min:0, max:100, step:1, unit:'öre', factor:100, gated:true,
    desc:'Högre värde = HEMS behåller hellre din solel och batteriets energi i huset än säljer och köper tillbaka. Det huset köper när elen är billig påverkas knappt. Ju högre värde, desto färre affärer med nätet och något lägre besparing.' },
  /* v930 (TILL_DESIGN_fyll_vid_billig_el 26/10): samma etikett, spann och texter som settings-mode.jsx. Nollraden (F4) är den enda i fliken. */
  { field:'fill_cheap_level', label:'Fyll vid billig el', min:0, max:10, step:1, unit:'', gated:true,
    desc:'Högre värde gör att batteriet fylls mer när elen är som billigast och hålls fullare under billiga timmar. Ju dyrare elen är, desto mindre extra fyllning. Batteriet används fortfarande när elen är dyr. Det kan kosta något i besparing och ger fler köp av billig el.',
    zero:'Av — batteriet planeras som i dag, utan extra fyllning vid billig el.' },
  { field:'soc_planning_buffer_pct', label:'Morgonbuffert', min:0, max:20, step:1, unit:'%', gated:true,
    desc:'Extra reserv ovanpå din lägsta batterinivå som kvällens planering sparar till morgonen. Vid midnatt släpps spärren. Är kvällen tydligt dyrare än morgonen kan bufferten släppas redan på kvällen, se Släpp morgonbufferten vid.' },
  { field:'soc_buffer_release_ore', label:'Släpp morgonbufferten vid', min:0, max:500, step:1, unit:'öre', gated:true,
    desc:'Så mycket dyrare kvällen (kl 18–24) måste vara än morgonen därpå (kl 00–09, eller tills solen täcker) för att HEMS ska få använda morgonbufferten redan på kvällen. Avgörs när morgondagens priser kommit, runt kl 13. Nås inte skillnaden hålls bufferten till midnatt som vanligt. Standard 30 öre. Högre värde = bufferten hålls oftare, 0 = släpps så fort kvällen är dyrare.' },
];

const GCI_ALWAYS = { field:'cycle_cost_ore', label:'Batterislitage', min:0, max:100, step:1, unit:'öre',
  desc:'Slitage per omsatt kWh. Högre värde gör HEMS mer sparsam med laddcyklerna — den handlar bara när vinsten överstiger slitaget. Det är den ratt som i hans prototyp heter Handelsmarginal.' };

/* Läser backendens settings-dokument. null/saknad = ojusterad. */
function gciRead(s){
  const d = s || {};
  const num = (v) => (v === null || v === undefined || v === '') ? null : Number(v);
  const out = {
    traj_premie_ore_per_kwh_h: num(d.traj_premie_ore_per_kwh_h),
    sellsolar_min_price_ore: num(d.sellsolar_min_price_ore),
    maxprofit_import_aversion_kr: d.maxprofit_import_aversion_kr == null ? null : Math.round(Number(d.maxprofit_import_aversion_kr)*100),
    fill_cheap_level: num(d.fill_cheap_level),
    soc_planning_buffer_pct: num(d.soc_planning_buffer_pct),
    soc_buffer_release_ore: num(d.soc_buffer_release_ore),
    cycle_cost_ore: d.cycle_cost_kwh ?? d.cycle_cost_ore ?? 10,
  };
  out.user_mode_enabled = (d.user_mode_enabled === true || d.user_mode_enabled === false)
    ? d.user_mode_enabled
    : GCI_KNOBS.some(k => out[k.field] != null);
  return out;
}

function GciKnob({ k, value, fleet, onChange, disabled }){
  const set = value != null;
  const shown = set ? value : fleet;
  return (
    <div className={`border-t border-slate-800 pt-3 ${disabled ? 'pointer-events-none opacity-40' : ''}`}>
      <div className="flex items-baseline justify-between gap-2">
        <span className="text-sm font-bold text-slate-100">{k.label}</span>
        <span className="flex items-baseline gap-2">
          <span className="text-sm font-bold" style={{...window.GC_MONO, color: set ? '#7dd3fc' : '#64748b'}}>
            {shown}{k.unit ? ' ' + k.unit : ''}
          </span>
          {!set && <span className="text-[10px] text-slate-500">Gravios standard</span>}
        </span>
      </div>
      <input type="range" min={k.min} max={k.max} step={k.step} value={shown}
        onChange={(e)=>onChange(Number(e.target.value))} className="mt-1.5 w-full accent-sky-400"/>
      {k.zero && Number(shown) === 0 && (
        <p className="mt-1 text-[11px] font-semibold leading-relaxed text-slate-300">{k.zero}</p>
      )}
      <div className="mt-1 flex items-start justify-between gap-3">
        <p className="text-[11px] leading-relaxed text-slate-500">{k.desc}</p>
        {set && (
          <button onClick={()=>onChange(null)}
            className="shrink-0 text-[11px] font-semibold text-slate-500 hover:text-slate-300">återställ</button>
        )}
      </div>
    </div>
  );
}

function GcInstallningar({ settings, onSaved }){
  /* "Inte hämtat än" är INTE samma sak som "inga rattar satta". Utan den här
     vakten härleder gciRead(undefined) user_mode_enabled till false under den
     dryga sekund settings saknas — fliken visar då "Automatisk drift" fast
     backend säger true. Värre: rör användaren gaten i det fönstret sätts
     dirty, re-seedingen hoppas över permanent, och Spara postar
     user_mode_enabled:false. Exakt samma fälla som EV-kortet hade när det
     läste gammal config efter sparning (m0045). */
  if (!settings) {
    return (
      <div className="rounded-2xl border border-slate-800 bg-slate-900/40 px-4 py-6 text-sm text-slate-400">
        Hämtar inställningar…
      </div>
    );
  }
  return <GcInstallningarBody settings={settings} onSaved={onSaved}/>;
}

function GcInstallningarBody({ settings, onSaved }){
  const incoming = React.useMemo(() => gciRead(settings), [settings]);
  const sig = JSON.stringify(incoming);
  const [v, setV] = React.useState(incoming);
  const [dirty, setDirty] = React.useState(false);
  const [saving, setSaving] = React.useState(false);
  const [toast, setToast] = React.useState('');
  React.useEffect(() => { if (!dirty) setV(incoming); }, [sig]);
  const set = (patch) => { setV({ ...v, ...patch }); setDirty(true); setToast(''); };

  const save = async () => {
    setSaving(true);
    try {
      await window.gcSaveSettings((cur) => {
        const base = gciRead(cur);
        const payload = { ...cur, user_mode_enabled: !!v.user_mode_enabled };
        /* §3.3: satt värde skickas, ojusterat UTELÄMNAS, och en ratt som var
           satt och nu är återställd skickas som explicit null. Baseline läses
           ur det FÄRSKA dokumentet — annars kan en omläsning efter 409 skicka
           null för en ratt som hann bli satt av någon annan. */
        for (const k of GCI_KNOBS){
          const val = v[k.field];
          const wasSet = base[k.field] != null;
          if (val != null) payload[k.field] = k.factor ? Number(val)/k.factor : Number(val);
          else if (wasSet) payload[k.field] = null;
          else delete payload[k.field];
        }
        payload.cycle_cost_kwh = Number(v.cycle_cost_ore);
        return payload;
      }, 'driftrattar');
      setDirty(false); setToast('ok');
      if (onSaved) onSaved();
    } catch(e){ setToast(e && /ändrades av någon annan/.test(e.message) ? 'conflict' : 'err'); }
    setSaving(false);
  };

  const on = !!v.user_mode_enabled;

  return (
    <div className="flex flex-col gap-3">
      <div className="rounded-2xl border border-slate-800 bg-slate-900/40 px-4 py-3">
        <div className="text-[10px] font-semibold uppercase tracking-[0.15em] text-slate-500">Driftinställningar</div>
        <p className="mt-1 text-sm leading-relaxed text-slate-400">
          Värdena styr hur HEMS prioriterar mellan att lagra, sälja och köpa. Gravios
          standardvärden passar de flesta anläggningar — rör ratten bara om du vill
          styra åt ett särskilt håll.
        </p>
        <div className="mt-3 flex gap-1">
          {[{ id:false, t:'Automatisk drift', d:'Gravios kalibrerade värden' },
            { id:true,  t:'Egna inställningar', d:'du skruvar själv' }].map(o => (
            <button key={String(o.id)} onClick={()=>set({ user_mode_enabled:o.id })}
              className={`flex-1 rounded-lg border px-2 py-1.5 text-center transition-colors ${
                on === o.id ? 'border-sky-400 bg-sky-500/15 text-sky-300'
                            : 'border-slate-700 bg-slate-800/70 text-slate-400 hover:text-slate-200'}`}>
              <div className="text-xs font-bold">{o.t}</div>
              <div className="truncate text-[9px] font-normal text-slate-500">{o.d}</div>
            </button>
          ))}
        </div>
        {!on && (
          <p className="mt-2 text-[11px] leading-relaxed text-slate-500">
            HEMS kör flottans inställningar. Dina egna värden ligger kvar och används
            igen när du byter tillbaka.
          </p>
        )}
      </div>

      <div className="rounded-2xl border border-slate-800 bg-slate-900/40 px-4 py-3.5">
        <div className="mb-1 flex items-baseline justify-between gap-2">
          <span className="text-sm font-bold text-slate-100">Egna värden</span>
          <span className="text-[10px] text-slate-500">{on ? 'aktiva' : 'inaktiva just nu'}</span>
        </div>
        <div className="flex flex-col gap-3">
          {GCI_KNOBS.map(k => (
            <GciKnob key={k.field} k={k} value={v[k.field]} fleet={GCI_FLEET[k.field]}
              disabled={!on} onChange={(x)=>set({ [k.field]:x })}/>
          ))}
        </div>
      </div>

      <div className="rounded-2xl border border-slate-800 bg-slate-900/40 px-4 py-3.5">
        <div className="mb-1 text-sm font-bold text-slate-100">Gäller alltid</div>
        <GciKnob k={GCI_ALWAYS} value={v.cycle_cost_ore} fleet={10}
          onChange={(x)=>set({ cycle_cost_ore: x == null ? 10 : x })}/>
      </div>

      <div className="flex items-center justify-end gap-3">
        {toast === 'ok'  && <span className="text-xs font-semibold text-emerald-400">Sparat — gäller från nästa planering</span>}
        {toast === 'err' && <span className="text-xs font-semibold text-rose-400">Kunde inte spara — försök igen</span>}
        {toast === 'conflict' && <span className="text-xs font-semibold text-rose-400">Ändrat på annat håll — läs in sidan igen</span>}
        {dirty && !toast && <span className="text-xs font-semibold text-amber-300">Osparade ändringar</span>}
        <button onClick={save} disabled={!dirty || saving}
          className={`rounded-lg border px-4 py-1.5 text-sm font-bold transition-colors ${
            (!dirty || saving) ? 'border-slate-800 bg-slate-900/50 text-slate-600'
                               : 'border-sky-500/50 bg-sky-500/15 text-sky-200 hover:bg-sky-500/25'}`}>
          {saving ? 'Sparar…' : 'Spara'}
        </button>
      </div>

      <a href="settings.html"
        className="flex items-center justify-between gap-3 rounded-2xl border border-slate-800 bg-slate-900/40 px-4 py-3">
        <span>
          <span className="block text-sm font-bold text-slate-200">Alla inställningar</span>
          <span className="mt-0.5 block text-xs text-slate-500">
            Batteri, sol, elavtal, effektavgift, laddboxar och bilprofiler.
          </span>
        </span>
        <span className="shrink-0 text-lg text-slate-500">›</span>
      </a>

    </div>
  );
}

Object.assign(window, { GcInstallningar, GcInstallningarBody, gciRead });
